import { API } from '../../../../config';
import { errorHandler } from '../../auth/errorAction';

export const unmountListSubDistricts = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_SUB_DISTRICT'})
}

export const unmountDetailSubDistricts = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_SUB_DISTRICT'})
}

export const unmountMasterSubDistricts = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_SUB_DISTRICT'})
}

export const listSubDistricts = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_SUB_DISTRICT' })
  return API.GET('/sub-district/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_SUB_DISTRICT_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_SUB_DISTRICT_FAILED' }), 
    ))
  })
}

export const detailSubDistrict = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_SUB_DISTRICT' })
  const params = {
    'id': id
  }
  API.GET('/sub-district/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_SUB_DISTRICT_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_SUB_DISTRICT_FAILED' }), 
      ))
    )
  })
}

export const masterSubDistricts = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_SUB_DISTRICT' })
  return API.GET('/sub-district/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_SUB_DISTRICT_SUCCESS', 
      payload: { data: response.data }
    })
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_SUB_DISTRICT_FAILED' }), 
    ))
  })
}

export const subDistrictByCity = (id, successCB, failedCB) => async (dispatch) => {
  const params = { 'id': id }
  API.GET('/sub-district/getByCityId', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(err))
    )
  })
}

export const createSubDistrict = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/sub-district/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editSubDistrict = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/sub-district/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableSubDistrict = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/sub-district/enable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableSubDistrict = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/sub-district/disable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}